import SurveyStatusPage from "./survey-status.page";

export default SurveyStatusPage;
